<template>
  <div>
    <div class="flex center flex-column w-100 h-100 pb6">
      <div class="intro w-50 tc center w-100 pt4">
        <header class="pt3 pb2">
          <h3>Experiment</h3>
          <h1>Visual Crosswords</h1>
        </header>
      </div>

      <div class="level-picker w-60-l w-80-m w-90 center">
        <div class="w-100 ph4-l ph3-m ph2 fw5 lh-copy">
          <p class="f5 black-70 mb0 pb0">Play with crosswords using images like letters!</p>
          <p class="f6 black-50 pt0 mt0">Drag artworks to boxes anywhere they match the labels</p>
        </div>
        <div class="levels w-100 center flex flex-wrap flex-row mb5">
          <div
            v-for="level in levels"
            :key="level"
            class="level w-20-l w-20-m w-25 pa4-l pa3-m pa2"
          >
            <div class="level-container br2 active" v-if="maxLevel >= level" @click="goToLevel(level)">
              <!-- <img :src="`./levels/level${level+1}.pngxy`" alt /> -->
              <div class="aspect-ratio aspect-ratio--1x1 br2">
                <div
                  class="aspect-ratio--object cover br2 bg-center"
                  :style="`background:url(./levels/level${level+1}.svg)`"
                ></div> 
              </div>
            </div>
            <div class="level-container locked br2" v-else>
              <!-- <img :src="`./public/levels/lock.png`" alt /> -->
              <div class="aspect-ratio aspect-ratio--1x1 br2">
                <div
                  class="aspect-ratio--object cover bg-grey br2"
                  style="background:url(./levels/lock.svg)"
                ></div>
              </div>
            </div>
            <p class="tc w-100 complete f6 pointer o-100" v-if="maxLevel >= level" @click="goToLevel(level)">{{levelsnames[level]}}</p>
            <div class="blurredname w-80 center bg-grey mt3" v-if="maxLevel < level"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Demo from "./Demo";

export default {
  methods: {
    goToLevel: function(level) {
      console.log("level:set", level);
      this.$root.$emit("level:set", level);
    }
  },
  props: {
    levels: Array,
    maxLevel: Number,
    levelsnames: Array,
    currentlevel:Number,
  },
  components: {
    //Demo
  }
};
</script>

<style scoped>

header{
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 100;
  background-color:white;
}

header h3{
      margin: 0;
    position: relative;
    z-index: 1;
    color: #bbb;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
}

header h1{
      margin: 0;
    position: relative;
    z-index: 1;
    color: #3c4043;
    font-size: 24px;
    font-weight: 500;
}

.level-picker{
  margin-top:100px;
}

.menu {
  background-color:white;
  position:absolute;
  height:100%;
  z-index:0;
  /* transform: translateX(-100%); */
  transition: 0.4s opacity;
  opacity:0;
}

.menuvisible{
  /* transform: translateX(0px); */
  opacity:1;
  z-index:100;
}

.level-container {
  cursor: pointer;
  /* background: #669df6; */
  background-color: rgb(231, 241, 253);
}

.active:hover{
  background-color: #D2E3FC;
}

.locked {
  background: #d4d4d4;
  cursor: default;
}

.complete{
  color:#669df6;
  opacity:1;
  /* opacity:1; */
}

.blurredname{
  height:1rem;
  background-color:#eeeeee;
  filter: blur(4px);
}


.backtogame {
  display: flex;
  font-size: 25px;
  padding: 10px;
  margin: 0;
  border-radius: 5px;
  padding: 10px;
  z-index: 100;
  cursor: pointer;
  height:48px;
  transition:background-color 0.2s ease;
}

</style>
